module.exports = "../study/imgs/maps/Tokyo/GWQ8/Climate/HourlyPrecipitation30/Tokyo_HourlyPrecipitation30_MRI_RCP85_End.png";